import React, { createContext } from 'react';

export const StudentAuthContext = createContext(null);